module.exports = __webpack_public_path__ + "img/2099.3a6ddc84.svg";